var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-wechat',
                        view: publicPath + 'sprite.svg#view-icon-wechat',
                        viewBox: '0 0 77 18',
                        title: 'Icon / WeChat Pay',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };